import type { InstrumentedMethodRegistry } from '../ai/utils';

export const GOOGLE_GENAI_INTEGRATION_NAME = 'Google_GenAI';

// https://ai.google.dev/api/rest/v1/models/generateContent
// https://ai.google.dev/api/rest/v1/chats/sendMessage
// https://googleapis.github.io/js-genai/release_docs/classes/models.Models.html#generatecontentstream
// https://googleapis.github.io/js-genai/release_docs/classes/chats.Chat.html#sendmessagestream
export const GOOGLE_GENAI_METHOD_REGISTRY = {
  'models.generateContent': { operation: 'generate_content' },
  'models.generateContentStream': { operation: 'generate_content', streaming: true },
  'models.embedContent': { operation: 'embeddings' },
  'chats.create': { proxyResultPath: 'chat' },
  'chat.sendMessage': { operation: 'chat' },
  'chat.sendMessageStream': { operation: 'chat', streaming: true },
} as const satisfies InstrumentedMethodRegistry;

// Constants for internal use
export const GOOGLE_GENAI_SYSTEM_NAME = 'google_genai';



// WEBPACK FOOTER //
// ../../../../src/tracing/google-genai/constants.ts